<template>
  <div class="case-detail-container page-common-detail-container" v-if="detail">
    <div class="detail__wrapper">
      <template v-if="isPreview">
        <div class="preview-title-page">
          <p class="title__text">案例预览</p>
          <a class="title__link">返回编辑</a>
        </div>
      </template>
      <!-- 轮播 -->
      <DetailSwiper :caseid="detail.lq_case_id" :pictures="pictures" :options="{
        autoplay: false,
        loop: true,
        pagination: {
          el: '.swiper__pagination',
        },
        navigation: {
          nextEl: '.swiper__direction-bts .--next',
          prevEl: '.swiper__direction-bts .--prev',
        },
      }" labelShow enable-preview :is-preview="isPreview"></DetailSwiper>
      <!-- 基础信息 -->
      <div class="detail__base-info" v-if="!isPreview">
        <div class="base-info__item" v-if="caseStore.logo_picture_url">
          <router-link class="item__logo hoverinto" :data-name="caseStore.name" tag="div" :to="{
            path: `${onPath(detail)}`,
          }">
            <img :src="caseStore.logo_picture_url | parseImage" alt="" />
          </router-link>
          <div class="item__base">
            <p class="base__name">{{ caseStore.name }}</p>
            <div class="base__type">
              <div class="type__child">
                <sign style="margin:0 10px 0 0;" :sign="caseStore.sign"
                  v-if="Number(caseStore.type) === 1 && Number(caseStore.sign) > 0"></sign>
              </div>
              <div class="type__child">
                <p class="type__text">
                  {{
                    Number(caseStore.type) === 2
                    ? "认证经销商"
                    : Number(caseStore.type) === 1
                      ? "厂家直营店"
                      : ""
                  }}
                </p>
                <el-rate class="type__rate" disabled v-model="stars"></el-rate>
              </div>
            </div>
            <div class="base-tag">
              <p class="base__bt" v-for="(c, index) in caseStore.cityList" :key="index">{{ c }}</p>
            </div>
          </div>
        </div>
        <div class="base-info__item" v-else>
          <router-link class="item__logo hoverinto" :data-name="caseStore.name" tag="div" :to="{
            path: `/member/${caseStore.user_id}/cases`,
          }">
            <img :src="caseStore.logo_picture_urls" alt="" />
          </router-link>
          <div class="item__base">
            <p class="base__name">{{ caseStore.name }}</p>
            <div class="base__type">
              <p class="type__text">设计师</p>
              <el-rate class="type__rate" disabled v-model="stars"></el-rate>
            </div>
            <div class="base-tag">
              <p class="base__bt" v-for="(c, index) in caseStore.cityList" :key="index">{{ c }}</p>
            </div>
          </div>
        </div>
        <template v-if="$isMobile">
          <div class="base-info__item">
            <div class="item__other-info">
              <div class="info__item">
                <p class="item__title">Corporate Name | 公司名称</p>
                <p class="item__val">{{ caseStore.name }}</p>
              </div>
              <div class="info__item">
                <p class="item__title">Project Location | 项目地点</p>
                <p class="item__val">{{ detail.prov_name }}</p>
              </div>
            </div>
            <div class="item__other-info">
              <div class="info__item">
                <p class="item__title">Project Name | 项目名称</p>
                <p class="item__val">{{ detail.title }}</p>
              </div>
              <div class="info__item">
                <p class="item__title">Material Science | 材料</p>
                <p class="item__val">{{ detail.mold_names }}</p>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="base-info__item">
            <div class="item__other-info">
              <div class="info__item">
                <p class="item__title">Corporate Name | 公司名称</p>
                <p class="item__val">{{ caseStore.name }}</p>
              </div>
              <div class="info__item">
                <p class="item__title">Project Location | 项目地点</p>
                <p class="item__val">{{ detail.prov_name }}</p>
              </div>
            </div>
          </div>
          <div class="base-info__item">
            <div class="item__other-info">
              <div class="info__item">
                <p class="item__title">Project Name | 项目名称</p>
                <p class="item__val">{{ detail.title }}</p>
              </div>
              <div class="info__item">
                <p class="item__title">Material Science | 材料</p>
                <p class="item__val">{{ detail.mold_names }}</p>
              </div>
            </div>
          </div>
        </template>
      </div>
      <!-- 详情 -->
      <div class="detail__multi-info mobileActionShowSign">
        <div class="info__head">
          <div class="head__item" @click="currentShow = 'detail'" :class="[currentShow === 'detail' ? 'active' : '']">
            案例详情
          </div>
          <div class="head__item" @click="currentShow = 'info'" :class="[currentShow === 'info' ? 'active' : '']"
            v-if="userInfo.identity != 4">
            项目信息
          </div>
          <div class="head__item" @click="currentShow = 'viewers'" :class="[currentShow === 'viewers' ? 'active' : '']">
            最近浏览
          </div>
        </div>
        <div class="info__content-wrapper">
          <div class="info__content" v-html="detail.content" v-if="currentShow === 'detail'"></div>
          <div class="info__content" v-if="currentShow === 'info'">
            <p>业务类型：{{ detail.business_type }}</p>
            <p>项目类型：{{ detail.case_type }}</p>
            <p v-if="detail.identity == 4 || detail.identity == 8">
              材料企业：{{ detail.material_company }}
            </p>
            <p>开发年份：{{ detail.over_year }}</p>
            <p>设计单位：{{ detail.design_unit }}</p>
            <p>开发建设单位：{{ detail.development_unit }}</p>
            <p>是否为示范区：{{ detail.is_model == 1 ? "是" : "否" }}</p>
          </div>
          <div class="info__viewers-container" v-if="currentShow === 'viewers'">
            <template v-if="detail.browseList.length > 0">
              <swiper class="viewer-swiper-container" :options="viewerSwiperOption" ref="viewSwiper">
                <swiper-slide class="viewer-swiper-slide" v-for="viewer in detail.browseList" :key="viewer.user_id">
                  <div class="viewer__info-box" @click="jump" :data-userid="viewer.user_id"
                    :data-storeid="viewer.store_id ? viewer.store_id : 0">
                    <div class="viewer__pic">
                      <img :src="viewer.avatar" alt="" />
                    </div>
                    <p class="viewer__name">{{ viewer.nickname }}</p>
                  </div>
                </swiper-slide>
              </swiper>
              <div class="viewer-swiper-pagination"></div>
              <div class="viewer-swiper-navigation">
                <div class="viewer-swiper-button-prev"></div>
                <div class="viewer-swiper-button-next"></div>
              </div>
            </template>
            <template v-else>
              <p>这个案例还未被其他人发现！</p>
            </template>
          </div>
        </div>
      </div>
      <!-- 按钮 -->
      <detail-bottom-bts v-if="!isPreview" :is-collect="detail.is_collection === 1" :id="Number(detail.id)"
        :type="$dict.COLLECT_TYPE.case" :qrcode="detail.qrcode_url" @claim="onClaim"
        :blog-page="'case'"></detail-bottom-bts>
      <!-- 评论 -->
      <template v-if="!isPreview">
        <div class="detail__reply-form" v-if="!$isMobile">
          <div class="form__textarea">
            <textarea placeholder="在这里你可以说些什么" v-model="text.reply"></textarea>
          </div>
          <el-button class="form__submit" :loading="loading.reply" @click="onReply">评论</el-button>
        </div>
        <!-- 评论列表 -->
        <template v-if="detail">
          <reply-list :lists="detail.commentList"></reply-list>
        </template>
      </template>
    </div>
    <template v-if="!isPreview">
      <div class="detail__recommend-container">
        <div class="recommend__wrapper">
          <div class="recommend__cases-container">
            <div class="recommend__title">
              <p>Project cases</p>
              <p>同类推荐</p>
              <router-link class="viewmore" tag="div" :to="{
                path: '/search/case',
              }">查看更多</router-link>
            </div>
            <div class="recommend__lists-wrapper">
              <CaseList :cases="recommendCase" theme="swiper"></CaseList>
            </div>
          </div>
          <div class="recommend__merchants-container" v-if="detail && detail.storeProducts.length > 0">
            <div class="recommend__title">
              <p>product</p>
              <p>产品推荐</p>
            </div>
            <div class="recommend__lists-wrapper">
              <product-list :products="detail.storeProducts" :isShowPagination="null"
                :storeLogo="detail.case_store.logo_picture_url"></product-list>
            </div>
          </div>
          <div class="recommend__merchants-container" v-if="false">
            <div class="recommend__title">
              <p>store</p>
              <p>推荐商家</p>
            </div>
            <div class="recommend__lists-wrapper">
              <MerchantList :merchants="brandList" theme="swiper"></MerchantList>
            </div>
          </div>
          <div class="recommend__merchants-container">
            <div class="recommend__title">
              <p>ARTICLE</p>
              <p>推荐文章</p>
            </div>
            <div class="recommend__lists-wrapper">
              <recommendArticleList ref="recommendArticleList" theme="swiper"></recommendArticleList>
            </div>
          </div>
        </div>
      </div>
      <template v-if="detail && showClaim">
        <claim :id="detail.id" :type="1" :mold-id="detail.mold_id" @cancel="onClaimCancel"></claim>
      </template>
    </template>
    <template v-if="$isMobile">
      <action-hint :bts="[
        {
          text: '收藏',
          bg: '#007fd9',
          color: '#fff',
        },
      ]"></action-hint>
    </template>
  </div>
</template>

<script>
import CaseList from "@/pages/case/_list.vue";
import MerchantList from "@/pages/merchant/_list.vue";
import DetailSwiper from "@/pages/common/detailSwiper.vue";
import DetailBottomBts from "@/pages/common/detailBottomBts.vue";
import Claim from "@/pages/common/claim.vue";
import { handlerDetailReply } from "@/assets/utils/handler";
import ReplyList from "@/pages/common/replies.vue";
import { mapState } from "vuex";
import localstorage from "@/assets/utils/localstorage";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import actionHint from "@/pages/common/mobile-action-hint.vue";
import recommendArticleList from "@/components/recommendArticleList.vue";
import ProductList from "@/pages/product/_list.vue";
import Sign from '@/pages/merchant/_sign.vue'

export default {
  components: {
    CaseList,
    MerchantList,
    DetailSwiper,
    DetailBottomBts,
    ReplyList,
    Claim,
    Swiper,
    SwiperSlide,
    actionHint,
    recommendArticleList,
    ProductList,
    Sign
  },
  data() {
    return {
      pictures: null,
      caseStore: null,
      brandList: null,
      recommendCase: null,
      detail: null,
      stars: 5,
      loading: {
        reply: false,
      },
      text: {
        reply: "",
      },
      showClaim: false,
      currentShow: "detail",
      viewerSwiperOption: {
        init: false,
        autoplay: {
          delay: 2000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        loop: true,
        slidesPerView: this.$isMobile ? 6 : 10,
        slidesPerGroup: this.$isMobile ? 6 : 10,
        pagination: {
          el: ".viewer-swiper-pagination",
        },
        navigation: {
          nextEl: ".viewer-swiper-button-next",
          prevEl: ".viewer-swiper-button-prev",
        },
      },
    };
  },
  computed: mapState({
    userInfo: ({ user: { info } }) => info || {},
    isPreview() {
      return this.$route.name === "case-preview";
    },
  }),
  watch: {
    $route: {
      handler() {
        if (this.isPreview) {
          this.detail = localstorage.get("CASE_PREVIEW_DATA");
          this.pictures = this.detail.picture_ids;
        } else {
          this.getData();
        }
        this.$store.commit("SET_LOGIN_TITLE", "如何收藏？");
      },
      immediate: true,
    },
  },
  updated() {
    if (this.currentShow === "viewers" && this.detail && this.detail.browseList.length > 10) {
      this.$refs.viewSwiper.$swiper.init();
    } else if (this.currentShow === "detail" && this.$refs.viewSwiper) {
      this.$refs.viewSwiper.$swiper.destroy();
    }
  },
  methods: {
    getData() {
      this.$store.commit("openLoading");
      this.recommendCase = [];
      this.brandList = [];
      this.$http
        .post("html/caseller/caseDetail", {
          id: this.$route.params.id,
        })
        .then((res) => {
          this.detail = res.data;
          this.pictures = res.data.picture_ids;
          this.caseStore = res.data.case_store;
          this.stars = this.caseStore.level;
          this.brandList = res.data.brandList;
          this.recommendCase = res.data.recommendCase;
          this.$nextTick(() => {
            this.$refs.recommendArticleList.getList(res.data.mold_id);
          });
        })
        .finally(() => {
          this.$store.commit("closeLoading");
        });
    },
    onReply() {
      this.loading.reply = true;
      handlerDetailReply(this.detail.id, this.text.reply, this.$dict.COLLECT_TYPE.case)
        .then(() => {
          this.$message({
            type: "success",
            message: "评论成功",
          });
          this.detail.commentList.push({
            id: -1,
            can_del: -1,
            centent: this.text.reply,
            ctime: Math.floor(new Date().getTime() / 1000),
            fabulous_num: 0,
            picture_ids: [],
            user_id: this.userInfo.id,
            avatar: this.userInfo.avatar,
            user_name: this.userInfo.nickname,
          });
          this.text.reply = "";
        })
        .finally(() => {
          this.loading.reply = false;
        });
    },
    onClaim() {
      if (Number(this.detail.claim) === 1) {
        this.showClaim = true;
      } else {
        this.$message({
          type: "error",
          message: "该案例暂不可认领",
        });
      }
    },
    onClaimCancel() {
      this.showClaim = false;
    },
    jump(e) {
      const { userid, storeid } = e.currentTarget.dataset;
      const url = storeid > 0 ? `/merchant/${storeid}/cases` : `/member/${userid}`;
      this.$router.push({
        path: url,
      });
    },
    onPath(detail) {
      let path = `/merchant/${detail.store_id}/cases`;
      if (detail.identity == 8 || detail.identity == 4) path = `/member/${detail.user_id}/cases`;
      return path;
    },
  },
};
</script>

<style lang="scss" scoped>
.case-detail-container {
  .info__content {
    p {
      line-height: 24px;
    }
  }
}
</style>
